import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

import Popup from '../../helpers/Popup';
import Button from '../../helpers/Button';
import FormErrors from '../../helpers/FormErrors';
import { UserInfo } from '../../User/UserInfo';
import style from './style.module.css';

/**
 * Popup with the form to add or edit a user.
 *
 * @param {object} props Props, the rest of them are passed to the user form.
 * @param {boolean} props.isNew Whether a new user is being added.
 * @param {boolean} props.loading Whether the user is loading or saving.
 * @param {boolean} props.isSaveDisabled Whether the Save button is disabled.
 * @param {Immutable.List} props.commonErrors API errors not related to a form field.
 * @param {Function} props.onSave Handle the Save button click.
 * @param {Function} props.onCancel Handle the Cancel button click.
 */
const UserDetailsPopupComponent = ({ isNew, loading, isSaveDisabled, commonErrors, onSave, onCancel, ...rest }) => {
  const footer = (
    <>
      <Button className="btn-primary" disabled={isSaveDisabled} onClick={onSave}>
        Save
      </Button>
      <Button onClick={onCancel}>Cancel</Button>
    </>
  );

  return (
    <Popup
      className={style.host}
      footer={footer}
      header={isNew ? 'Add User' : 'Edit User'}
      id="userDetails"
      loading={loading}
    >
      <UserInfo {...rest} />
      <FormErrors errors={commonErrors} />
    </Popup>
  );
};

UserDetailsPopupComponent.propTypes = {
  commonErrors: PropTypes.instanceOf(List).isRequired,
  isNew: PropTypes.bool.isRequired,
  isSaveDisabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export const UserDetailsPopup = memo(UserDetailsPopupComponent);
